/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MockVRFCoordinator,
  MockVRFCoordinatorInterface,
} from "../MockVRFCoordinator";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "linkAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "keyHash",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "seed",
        type: "uint256",
      },
    ],
    name: "RandomnessRequest",
    type: "event",
  },
  {
    inputs: [],
    name: "LINK",
    outputs: [
      {
        internalType: "contract LinkTokenInterface",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "consumerContract",
        type: "address",
      },
    ],
    name: "callBackWithRandomness",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "onTokenTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MockVRFCoordinator__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    linkAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MockVRFCoordinator> {
    return super.deploy(
      linkAddress,
      overrides || {}
    ) as Promise<MockVRFCoordinator>;
  }
  getDeployTransaction(
    linkAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(linkAddress, overrides || {});
  }
  attach(address: string): MockVRFCoordinator {
    return super.attach(address) as MockVRFCoordinator;
  }
  connect(signer: Signer): MockVRFCoordinator__factory {
    return super.connect(signer) as MockVRFCoordinator__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockVRFCoordinatorInterface {
    return new utils.Interface(_abi) as MockVRFCoordinatorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockVRFCoordinator {
    return new Contract(address, _abi, signerOrProvider) as MockVRFCoordinator;
  }
}
